import React from 'react';
import { useSelector } from 'react-redux';
import Chart from './chart';

export default function Content() {
  const data = useSelector((state) => state.data.data);

  return (
    <div className="charts-wrap">
      {data.map((obj, index) => {
        return <Chart key={obj.religion} index={index} {...obj} />;
      })}
    </div>
  );
}
